import { Button } from '@tempo-io/sui-button';
import { Textarea } from '@tempo-io/sui-textarea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '../Select';

type CommentInputProps = {
  onSubmit: (comment: string, internal: boolean) => void;
  inputIdSuffix?: string;
  disabledInternalComments?: boolean;
};

const selectOptionValues = ['public', 'internal'];

export const CommentInput = ({
  onSubmit,
  inputIdSuffix,
  disabledInternalComments,
}: CommentInputProps) => {
  const { t } = useTranslation('translation');

  const [comment, setComment] = useState('');
  const [internal, setInternal] = useState(true);

  const postComment = () => {
    if (comment === '') return;

    onSubmit(comment, internal);
    setComment('');
  };

  const selectOptions = selectOptionValues.map((val) => ({
    value: val,
    label:
      val === 'internal'
        ? t('ideaManagement.general.internalComment')
        : t('ideaManagement.general.publicComment'),
  }));

  return (
    <div className="flex flex-col gap-1">
      <Textarea
        className="fs-exclude min-h-22"
        aria-label={t('ideaManagement.general.writeAComment')}
        data-dd-action-name="FIM 3 Comment - input redacted"
        value={comment}
        id={`idea-post-a-comment${inputIdSuffix ?? ''}`}
        placeholder={t('ideaManagement.general.writeAComment')}
        data-testid="fim3-idea-post-a-comment-input"
        onChange={(e) => setComment(e.target.value)}
      />
      <div className="flex justify-between pt-0.5 items-center">
        <div>
          {!disabledInternalComments && (
            <div
              data-testid="fim3-idea-comment-internal-select"
              className="uppercase text-text-neutral"
            >
              <Select
                menuItems={selectOptions}
                value={internal ? 'internal' : 'public'}
                onChange={(val) => setInternal(val === 'internal')}
              />
            </div>
          )}
        </div>
        <Button
          onClick={postComment}
          data-testid="fim3-idea-comment-post-button"
          disabled={!comment.trim()}
        >
          {t('ideaManagement.general.postComment')}
        </Button>
      </div>
    </div>
  );
};
